export default __webpack_public_path__ + "static/media/AuthSlideTwo.c20464b8.svg";